/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import ItemFeedback from 'bundles/content-feedback/components/cds/ItemFeedback';
import type { ItemType } from 'bundles/content-feedback/constants/ItemTypes';
import type { Item } from 'bundles/learner-progress/types/Item';

type Props = {
  className?: string;
  hideFeedback?: boolean;
  courseId?: string;
  computedItem?: Item;
  feedbackType?: ItemType;
};

const ItemBox: React.LegacyFunctionComponentWithChildren<Props> = ({
  className,
  computedItem,
  feedbackType,
  hideFeedback,
  children,
}) => {
  const itemBoxContentStyle = css`
    max-width: 960px;
    color: #1f1f1f;
    margin-top: var(--cds-spacing-300);
    ${breakpoints.up('sm')} {
      margin-top: var(--cds-spacing-400);
    }
    ${breakpoints.up('md')} {
      margin-top: var(--cds-spacing-600);
    }
  `;

  const itemFeedbackContainerStyle = css`
    border-top: 1px solid #ddd;
    padding: 15px 0;
    display: flex;
  `;

  return (
    <div className={className} css={itemBoxContentStyle}>
      {children}

      {!hideFeedback && computedItem && feedbackType && (
        <div css={itemFeedbackContainerStyle}>
          <ItemFeedback computedItem={computedItem} itemFeedbackType={feedbackType} />
        </div>
      )}
    </div>
  );
};

export default ItemBox;
